// src/components/PathsLanding.js
import React from "react";
import { Link } from "react-router-dom";
import "./PathsLanding.css";

const PATHS = [
  {
    id: "young",
    title: "Individual / Young Adult",
    description:
      "Find refunds, credits, and learn when filing matters — even if you don’t usually file.",
    icon: "👤",
    path: "/modules",
  },
  {
    id: "family",
    title: "Growing Family / Dependents",
    description:
      "Understand child-related tax benefits and how family changes affect your taxes.",
    icon: "👨‍👩‍👧",
   path: "/modules",
  },
  {
    id: "married-no-kids",
    title: "Married, No Children",
    description:
      "Learn how filing jointly works and how income and benefits interact over time.",
    icon: "💍",
   path: "/modules",
  },
  {
    id: "married-kids",
    title: "Married with Children",
    description:
      "Plan ahead with credits, education costs, and long-term family strategies.",
    icon: "👨‍👩‍👦",
   path: "/modules",
  },
  {
    id: "school",
    title: "Planning for School",
    description:
      "Explore education credits, tuition rules, and common student tax mistakes.",
    icon: "🎓",
    path: "/modules",
  },
  {
    id: "retirement",
    title: "Planning for Retirement",
    description:
      "Understand retirement accounts, tax advantages, and long-term planning concepts.",
    icon: "🏖️",
   path: "/modules",
  },
  {
    id: "business",
    title: "Small Business / Side Income",
    description:
      "Learn the basics of self-employment taxes and common early pitfalls.",
    icon: "🧾",
    path: "/modules",
  },
  {
    id: "real-estate",
    title: "Real Estate / Property Owner",
    description:
      "Understand rental income, property basics, and how assets change taxes.",
    icon: "🏠",
    path: "/modules",
  },
    {
    id: "GILDARC",
    title: "Amendments",
    description:
      "Learn how corrections of forms work.",
    icon: "🏠",
  path: "/modules",
  },
     {
    id: "GILDARC",
    title: "Happy Holidays!",
    description:
      "Some which are just applicable to all",
    icon: "🏠",
   path: "/modules",
  },
];

export default function PathsLanding() {
  return (
    <div className="paths-page">
      <header className="paths-header">
        <h1>Start with what applies to you</h1>
        <p>
          GILDARC helps you learn how taxes work based on your life situation —
          not confusing rules or income tables.
        </p>
      </header>

      <section className="paths-grid">
        {PATHS.map((p) => (
          <Link to={p.path} key={p.id} className="path-card">
            <div className="path-icon">{p.icon}</div>
            <h2>{p.title}</h2>
            <p>{p.description}</p>
            <span className="path-cta">Start learning →</span>
          </Link>
        ))}
      </section>

      <footer className="paths-footer">
        <p>
         
        </p>
     <Link
  to="/modules"
  className="inline-flex items-center text-left text-sm font-semibold text-blue-600 hover:underline"
>
  Go to Full Story Module →
</Link>


        
      </footer>
    </div>
  );
}
